import ArticleList from './article-list'
export default ArticleList



// WEBPACK FOOTER //
// ./src/common-components/article-list/index.js